import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-secondary-600">FAQ</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于入口、地址更新与客户端下载，用户问得最多的问题都整理在这里。点击问题即可展开查看解答。
            </p>
          </div>

          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">{faq.q}</span>
                    <i className={isOpen ? 'ri-subtract-line text-lg text-primary-600' : 'ri-add-line text-lg text-foreground-500'} aria-hidden="true" />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}